<template>
    <svg width="107" height="105" viewBox="0 0 107 105" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_851_14198)">
            <g clip-path="url(#clip1_851_14198)">
                <path
                    d="M52.9996 18.6195C71.6329 18.6195 86.7996 33.7862 86.7996 52.4195C86.7996 71.0529 71.6329 86.2195 52.9996 86.2195C34.3663 86.2195 19.1996 71.0529 19.1996 52.4195C19.1996 33.7862 34.3663 18.6195 52.9996 18.6195ZM52.9996 16.0195C32.8929 16.0195 16.5996 32.3129 16.5996 52.4195C16.5996 72.5262 32.8929 88.8195 52.9996 88.8195C73.1063 88.8195 89.3996 72.5262 89.3996 52.4195C89.3996 32.3129 73.1063 16.0195 52.9996 16.0195Z"
                    fill="#230078" />
                <path
                    d="M58.1988 70.6199C58.1988 67.748 55.8707 65.4199 52.9988 65.4199C50.1269 65.4199 47.7988 67.748 47.7988 70.6199C47.7988 73.4918 50.1269 75.8199 52.9988 75.8199C55.8707 75.8199 58.1988 73.4918 58.1988 70.6199Z"
                    fill="#84BD00" />
                <path
                    d="M56.4655 29.0195H49.5322C48.5749 29.0195 47.7988 29.7956 47.7988 30.7529V58.4862C47.7988 59.4435 48.5749 60.2195 49.5322 60.2195H56.4655C57.4228 60.2195 58.1988 59.4435 58.1988 58.4862V30.7529C58.1988 29.7956 57.4228 29.0195 56.4655 29.0195Z"
                    fill="#84BD00" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_851_14198">
                <rect width="106.919" height="104" fill="white" transform="translate(0 0.419922)" />
            </clipPath>
            <clipPath id="clip1_851_14198">
                <rect width="104" height="104" fill="white" transform="translate(1 0.419922)" />
            </clipPath>
        </defs>
    </svg>


</template>